import { useState } from 'react';
import Select from '@mui/material/Select';
import {
  MenuSearchField,
  filterMenuChildren,
  countMenuItems,
} from './searchableMenu';

// Drop-in replacement for MUI <Select> that adds a search field to the top of
// the dropdown menu and filters the options as the user types. The search box
// only appears once the option count exceeds `searchThreshold`, so short fixed
// lists stay clean and behave exactly like a plain <Select>. All other props
// are forwarded to the underlying Select.
const SearchableSelect = ({
  children,
  searchThreshold = 1,
  searchPlaceholder = 'Search...',
  MenuProps,
  onClose,
  value,
  ...props
}) => {
  const [search, setSearch] = useState('');
  const showSearch = countMenuItems(children) > searchThreshold;

  if (!showSearch) {
    return (
      <Select {...props} value={value} MenuProps={MenuProps} onClose={onClose}>
        {children}
      </Select>
    );
  }

  return (
    <Select
      {...props}
      value={value}
      MenuProps={{ ...MenuProps, autoFocus: false }}
      onClose={(event) => {
        setSearch('');
        onClose?.(event);
      }}
    >
      <MenuSearchField
        key="__menu_search__"
        searchValue={search}
        onSearchChange={setSearch}
        placeholder={searchPlaceholder}
      />
      {filterMenuChildren(children, search, value)}
    </Select>
  );
};

export default SearchableSelect;
